import { render, staticRenderFns } from "./SectionProgramInformation.vue?vue&type=template&id=95e74604&scoped=true&"
import script from "./SectionProgramInformation.vue?vue&type=script&lang=js&"
export * from "./SectionProgramInformation.vue?vue&type=script&lang=js&"
import style0 from "./SectionProgramInformation.vue?vue&type=style&index=0&id=95e74604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e74604",
  null
  
)

export default component.exports